module.exports = __webpack_public_path__ + "img/printIndustrialIndex_bg.c7816a9d.jpg";